import useSeo from "@/lib/useSeo";
import { BookOpen } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

/**
 * Standalone School Visibility Playbook™ landing page.
 *
 * Per the build brief: not linked in main navigation. This page is reserved
 * for future use as a Visibility Check™ companion resource, email nurture
 * asset, and sales enablement tool. Live with a "Coming Soon" stub until
 * the final asset is ready.
 */
export default function SchoolVisibilityPlaybookPage() {
  useSeo({
    title:
      "School Visibility Playbook™ — ED Tech Depot",
    description:
      "Practical ideas and strategies used by schools to improve communication, recognition, and engagement.",
    path: "/school-visibility-playbook",
  });

  return (
    <div data-testid="playbook-page" className="min-h-screen bg-[#F4F6F4] flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center px-6 md:px-12 py-24 md:py-32">
        <div className="max-w-3xl text-center">
          <div className="cmyk-ribbon h-1 w-24 mx-auto mb-10 rounded-full" aria-hidden />
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-navy text-white mb-8">
            <BookOpen className="w-7 h-7" strokeWidth={2} />
          </div>
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            Companion resource · Coming soon
          </div>
          <h1
            data-testid="playbook-headline"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-navy leading-[1.05]"
          >
            School Visibility Playbook<sup className="text-2xl sm:text-3xl">™</sup>
          </h1>
          <p className="mt-8 text-lg sm:text-xl text-slate-600 leading-relaxed">
            A collection of practical ideas and strategies used by schools to
            improve communication, recognition, and engagement.
          </p>
          <p className="mt-6 text-base text-slate-500 leading-relaxed">
            The full Playbook is in development as a companion to the Visibility
            Check<sup>™</sup>. Check back soon, or take the Visibility Check
            <sup>™</sup> to be the first to receive it.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
